// JavaScript Document
//components/configuration/SettingStandard.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
//import Chip from '@material-ui/core/Chip';
//import AddIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done'
//import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import DisplayMode from './DisplayMode';
//import PowerPicker from './PowerPicker';
//import PowerInterval from '../configuration/PowerInterval';
//const utils = require('./Utils');
import dmodes from '../Modes';
//const Modes = dmodes();

const useStyles = makeStyles((theme) => ({

	interval : {
		textAlign: 'center',
		padding: 2,
		margin: 2,
		display: 'inline-block',
		maxWidth: 330,
		minWidth: 165,
	},
	intervalEdit : {
		textAlign: 'center',
		padding: 2,
		margin: 2,
		display: 'inline-block',
		maxWidth: 350,
		minWidth: 285
	},
	settingInput : {
		margin: theme.spacing(1),
		width: 90
	},
	settingInputText : {
		textAlign: 'center'
	},
	editButton : {
		textAlign: 'center',
		flexGrow: 1,
		width: '100%'
	},
	modeLabel: {
		textAlign: 'center',
		marginRight: theme.spacing(1)
	},
	chip : {
			margin: theme.spacing(0.5),
			//fontSize:'0.9em'
		},
	
}));

export default function Setting(props) {
  const classes = useStyles();
	//Inherited props
	//sign = sign object
	//config = config object
	//settings = eachSetting & intervals
	//onChange = inherited handler for making changes
  	const {sign, config, settings, onChange} = props;

	const Modes = dmodes(config.custom_modes);
	//State variables that can be updated independent of inherited props
	const [speed, setSpeed] = React.useState(25);
	const [op, setOp] = React.useState(1);
	//const [addable, setAddable] = React.useState(true);
	const [threshold, setThreshold] = React.useState(25);
	const [maxspeed, setMaxspeed] = React.useState(45);
	const [edit, setEdit] = React.useState(false);
	const [loaded, setLoaded] = React.useState(false);
	
	/* not used...
	//Popover state
	const [popper, setPopper] = React.useState({
		anchor: null,
		open : false,
		interval : []
	});
	*/
	
	//update state on props changes
  	React.useEffect(() => {
		//Only update if loading new daysetting
		setSpeed(settings.speed);
		setOp(settings.op);
		setThreshold(settings.threshold);
		setMaxspeed(settings.maxspeed);
		//Modes = dmodes(config.custom_modes);
		//console.log(displays);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	React.useEffect(() => {
		if(!loaded)
			setTimeout(() => setLoaded(true), 50);
	}, [loaded]);
	
	//Toggle view and edit mode
	const handleSwitchViewMode = (e) => {
		if(edit){
			//clicking "Done" apply changes
			if(onChange){
				onChange({speed: speed, op: op, threshold:threshold, maxspeed: maxspeed});
			}
		}
		setEdit(!edit);
	}
	
	//handle change setting value
	const handleChangeSettingValue = (e) => {
		let setting = e.target.name;
		let value = parseInt(e.target.value);
		//clean the value
		if(isNaN(value) || value < 0){
			value = 0;
		} else if(value > 99 
			&& setting !== 'op'){ //ignore upper boundary for mode (dynamic modes)
			value = 99;
		}
		switch(setting){
			case 'speed':
				setSpeed(value);
				break;
			case 'op':
				setOp(value);
				setLoaded(false);
				//setTimeout(() => setOp(parseInt(value)+1), 20);
				//setTimeout(() => setOp(value), 50);
				//setTimeout(() => setOp(value), 50);
				break;
			case 'threshold':
				setThreshold(value);
				break;
			case 'maxspeed':
				setMaxspeed(value);
				break;
			default:
				console.log("couldn't find setting "+setting);
		}
	}
	
	//Compile mode select options
	const modeItem = (mode, x) => {
		if(mode.special === 1){
			return "";
		}
		return (
			<MenuItem key={x} value={mode.id}>
				<Typography className={classes.modeLabel}>
					{x}
				</Typography>
				<DisplayMode sign={sign} config={config} settings={{speed : speed, op : mode.id, threshold : threshold, maxspeed : maxspeed}} />
			</MenuItem>
		);
	};
	//Edit TextFiled options
	const editOptions = () => {
		var inputTextProps = {
			min: '0',
			max: '99',
			style: {
				textAlign:'center'
			}
		};
		if(edit === true){
			return (
			<div style={{marginTop:10}}>
				<TextField 
						id="op" 
						name="op"
						label="Display Mode"
						select
						value={op.toString()} 
						onChange={handleChangeSettingValue}
						variant="outlined"
						type="number" 
						inputProps={inputTextProps}
					>
						{Modes.map(modeItem)}
					</TextField>
				<Grid container justifyContent="space-around">
					<TextField 
						id="speed" 
						name="speed"
						label="Speed Limit" 
						autoFocus={true}
						value={speed.toString()} 
						className={classes.settingInput} 
						onChange={handleChangeSettingValue}
						type="number" 
						inputProps={{min: '0', max:'99', step:'5', style: {textAlign:'center'}}}
					/>
					<TextField 
						id="threshold" 
						name="threshold"
						label="Threshold" 
						value={threshold.toString()} 
						className={classes.settingInput} 
						onChange={handleChangeSettingValue}
						type="number" 
						inputProps={inputTextProps}
					/>
					<TextField 
						id="maxspeed" 
						name="maxspeed"
						label="Max Speed" 
						value={maxspeed.toString()} 
						onChange={handleChangeSettingValue}
						className={classes.settingInput} 
						type="number" 
						inputProps={inputTextProps}
					/>
				</Grid>
			</div>
			)
		}
		return (
			<DisplayMode sign={sign} config={config} settings={{speed : speed, op : op, threshold : threshold, maxspeed : maxspeed}} />
		);
	}
	const editButtonIcon = () => {
		if(edit === true){
			return (<DoneIcon />);
		}
		return (<EditIcon />);
	}
  	return (
		<Paper className={edit ? classes.intervalEdit : classes.interval}>
			{props.children}
			{editOptions()}
			<Button
					variant="filled"
					color="primary"
					size="large"
					onClick={handleSwitchViewMode}
					className={classes.editButton}
					startIcon={editButtonIcon()}
				>
					{edit === true ? 'Done':'Edit'}
			</Button>
		</Paper>
  	);

}
